export function getSizeTypeFromLayoutSizeType(layoutSizeType) {
  return layoutSizeType === 'childWidth' ? 'width' : layoutSizeType === 'childHeight' ? 'height' : layoutSizeType;
}